<div id="dk-footer" class="dk-footer">
  <div class="container ">
    <div class="row ">

      <div class="col-md-4 " >
        <h4 style="color: white;text-align: center;"><i class="fas fa-database"></i> Ressources and Data</h4>
        <ul style="color: white;">
          <li><a href="https://api.covid19api.com/">Source 1</a></li>
          <li><a href="https://corona.lmao.ninja/All">Source 2</a></li>
          <li><a href="https://moroccostats.herokuapp.com/stats/coronavirus/countries/">Source 3</a></li>

        </ul>
      </div>
      <div class="col-md-4" >
        <h4 style="color: white;text-align: center;"><i class="fas fa-user-shield"></i> About</h4>
<p style="color: white;">Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi animi saepe debitis sed nisi,
   reprehenderit nostrum omnis provident qui nobis iusto itaque doloribus nihil velit deserunt corr
   upti cumque, ipsam explicabo?</p>
      </div>
      <div class="col-md-4" >
        <h4 style="color: white;text-align: center;"><i class="fas fa-id-card-alt"></i> My Contact</h4>
        <i class="icon-github-alt"></i>
        <i class="icon-facebook-sign"></i>
        <i class="icon-twitter"></i>
      </div>
    </div>
  </div>
  <div class="copyright">
    <div class="container">
      <div class="row">
        <div class="col-md-12" style="text-align: center;">
          <b> <span>Copyright © 2020, All Right Reserved To BENDRIMOU AYOUB</span></b>
        </div>
      </div>
    </div>
  </div>
</div>
